import React from "react";
import clsx from "clsx";
import useStyles from "./styles";
import Drawer from "@material-ui/core/Drawer";

function SiteDrawer(props) {
  const classes = useStyles();
  const {
    drawerType,
    isDrawerOpen,
    drawerCloseHandler,
    isBottomDrawer,
    children,
    isCustomDrawer,
    drawerWrapperClass,
    drawerBodyClass,
  } = props;

  return (
    <Drawer
      anchor={drawerType}
      open={isDrawerOpen}
      onClose={drawerCloseHandler}
      classes={{
        paperAnchorBottom: drawerWrapperClass
          ? drawerWrapperClass
          : isCustomDrawer
          ? classes.rootClass
          : "",
      }}
    >
      <div
        className={clsx(classes.sidePanel, {
          [classes.bottomPanel]: isBottomDrawer,
        })}
      >
        <div
          className={clsx(classes.drawerContent, {
            [classes.customDrawerContent]: isCustomDrawer,
            [drawerBodyClass]: !!drawerBodyClass,
          })}
        >
          {children}
        </div>
      </div>
    </Drawer>
  );
}

export default SiteDrawer;
